import { createAction, props } from '@ngrx/store'
import { FlightNetworkState, FlightNetworkCenterState, CenterStatus } from '../reducers/flight-network.reducer'
import { FlightNetwork } from 'src/app/flight-network/shared'

export const loadFlightNetwork = createAction('[FlightNetwork] Load FlightNetwork')
export const loadFlightNetworkSuccess = createAction(
  '[FlightNetwork] Load FlightNetwork Success',
  props<{ network: FlightNetworkState }>(),
)
export const loadFlightNetworkFailure = createAction(
  '[FlightNetwork] Load FlightNetwork Failure',
  props<{ error: any }>(),
)

export const editFlightNetwork = createAction('[FlightNetwork] Edit FlightNetwork', props<{ network: FlightNetwork }>())
export const editFlightNetworkSuccess = createAction('[FlightNetwork] Edit FlightNetwork Success')
export const editFlightNetworkFailure = createAction(
  '[FlightNetwork] Edit FlightNetwork Failure',
  props<{ error: any }>(),
)

export const updateFlightNetworkCenter = createAction(
  '[FlightNetwork] Update FlightNetwork Center',
  props<{ center: FlightNetworkCenterState }>(),
)
export const updateFlightNetworkCenterOpenState = createAction(
  '[FlightNetwork] Update FlightNetwork Center Open State',
  props<{ center_id: number; open_state: CenterStatus }>(),
)
